import { GridColumnMenu } from "@mui/x-data-grid-premium";
import { ToggleExpandedRows } from "./ToggleExpandTree";
import { ToggleHeaderFilter } from "./ToggleHeaderFilter";
import { TableViewSelector } from "./TableViewDropdown";
import { InspectionDialogButton } from "./InspectionDialog";
import { TESTING_FUNCTIONALITY } from "src/utils/enviromentValues";


export function CustomColumnMenu({ props, tableSettings, columns }) {
  const stop = (e: React.SyntheticEvent) => e.stopPropagation();

  return (
    <GridColumnMenu
      {...props}
      // prevent the whole column menu from auto-closing on clicks inside it
      closeMenuOnClick={false}
      slots={{
        columnMenuUserItem: (slotProps) => (
          // only stop events for *your* custom controls,
          // not for the entire GridColumnMenu
          <div onMouseDown={stop} onClick={stop}>
            <ToggleExpandedRows props={slotProps} tableSettings={tableSettings} />
            
            <TableViewSelector tableSettings={tableSettings} />
            <ToggleHeaderFilter props={slotProps} tableSettings={tableSettings} />
            {TESTING_FUNCTIONALITY && <InspectionDialogButton tableSettings={tableSettings} columns={columns} />}
          </div>
        ),
      }}
      slotProps={{ columnMenuUserItem: { displayOrder: 15 } }}
    />
  );
}